type ViewportFormFactor = 'desktop' | 'phone' | 'tablet' | undefined

export function isMobileSearchSurfaceVisible(
  formFactor: ViewportFormFactor,
  mobileSurfaceOpen: boolean,
): boolean {
  return formFactor !== 'phone' || mobileSurfaceOpen
}

export function openMobileSearchSurface(_mobileSurfaceOpen: boolean): boolean {
  return true
}
